import { User } from '../../../../../../models/CommentHistory/Comment';
import { User as ApiUser } from '../../Models/ApiComment';

export function toUser({
  name,
  is_pullrequest,
  reviewer_name,
  photo_url,
}: ApiUser): User {
  return {
    name,
    isPullRequest: is_pullrequest,
    reviewerName: reviewer_name,
    photoURL: photo_url,
  };
}
